const urgencies = ["SOS", "Immediate", "Couple Hours", "Days", "Weeks", ""]

export default urgencies;
